// STEP B  —  the script
//
//   • Themes → your theme → … → Edit code → Assets → calculator-rug.js
//   • Select all, replace with everything below. Save.
//   • Pricing maths is untouched. Test 7 on the Paste Sheet checkpoint is the one that matters.

// VRBB Rug Calculator — FSD v3 (structure refactor)
// Paste 3 of 3. Replaces assets/calculator-rug.js entirely.
//
// CUSTOM_CHECKOUT_ENABLED:
//   true  -> "Order this size" POSTs to the app proxy and redirects to invoice_url
//   false -> falls back to the pre-filled contact form in the Liquid block
//
// Changed from v2:
//   - each ft dropdown ends with an over-the-ceiling option that opens the quote form
//   - the in-stock match is a button that switches the shopper to the stocked variant
//   - price renders into an order summary panel, gated by the final-sale acknowledgment
//   - the empty prompt hides once a price exists
//   - the expandable coordination block now lives inside the IIFE
//
// Changed from v3:
//   - ceilings are handled in whole inches, so the inch dropdown can never offer a
//     combination the server will reject (8.92 ft -> 8 ft + 0..11 in; 9.0 ft -> 9 ft + 0 in)
//   - draft-order failures render the server's message instead of failing silently
//   - the ceiling sentence prints 8'11" rather than 8.92'
//   - a deep link to a size with no stock fills the calculator in on arrival, so the
//     shopper isn't asked to retype the size they just clicked (see applyPrefill)

(function () {
  'use strict';

  var CUSTOM_CHECKOUT_ENABLED = true;
  var DRAFT_ORDER_ENDPOINT = '/apps/vrbb/draft-order';
  var ORDER_LABEL = 'Order this size';
  var OVER = 'over';

  // ---------- utils ----------
  function calculatePrice(rate, widthIn, lengthIn) {
    return Math.ceil(rate * (widthIn / 12) * (lengthIn / 12) / 5) * 5;
  }
  function tradePrice(basePrice, tier) {
    if (tier === 'vip') return basePrice * 0.75;
    if (tier === 'trade') return basePrice * 0.80;
    return basePrice;
  }
  function toInches(feet, inches) {
    return parseInt(feet, 10) * 12 + parseInt(inches, 10);
  }
  function formatPrice(amount) {
    var hasCents = Math.round(amount * 100) % 100 !== 0;
    return '$' + amount.toLocaleString('en-US', {
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: 2
    });
  }
  function formatDimension(totalInches) {
    var feet = Math.floor(totalInches / 12);
    var inches = totalInches % 12;
    return feet + '\u2032' + inches + '\u2033';
  }
  function formatCeiling(totalInches) {
    var feet = Math.floor(totalInches / 12);
    var inches = totalInches % 12;
    return feet + '\u2032' + (inches ? inches + '\u2033' : '');
  }
  function trimFt(n) {
    return (Math.round(n * 10) / 10).toString().replace(/\.0$/, '');
  }
  function setText(id, txt) { var el = document.getElementById(id); if (el) el.textContent = txt; }
  function setVal(id, v) { var el = document.getElementById(id); if (el) el.value = v; }
  function show(el) { if (el) el.hidden = false; }
  function hide(el) { if (el) el.hidden = true; }

  // ---------- data ----------
  var dataEl = document.getElementById('vrbb-calculator-data');
  if (!dataEl) return;

  var rate = parseFloat(dataEl.dataset.rate);

  // Ceilings are stored as decimal feet (8.92) and validated as decimals server-side.
  // Work in whole inches so the configurable range always equals the orderable range.
  // +1e-6 absorbs float error: 8.92 * 12 evaluates to 107.03999999999999.
  var maxWidthIn = Math.floor(parseFloat(dataEl.dataset.maxWidth) * 12 + 1e-6);
  var maxLengthIn = Math.floor(parseFloat(dataEl.dataset.maxLength) * 12 + 1e-6);
  var maxWidthFt = Math.floor(maxWidthIn / 12);
  var maxLengthFt = Math.floor(maxLengthIn / 12);
  var isTrade = dataEl.dataset.isTrade === 'true';
  var tradeTier = dataEl.dataset.tradeTier;
  var productTitle = dataEl.dataset.productTitle || 'this rug';

  var inStockSizes = [];
  var instockEl = document.getElementById('vrbb-instock-data');
  if (instockEl) {
    try { inStockSizes = JSON.parse(instockEl.textContent) || []; } catch (e) { inStockSizes = []; }
  }
  function matchInStock(widthIn, lengthIn) {
    for (var i = 0; i < inStockSizes.length; i++) {
      var s = inStockSizes[i];
      var pw = Math.round(s.w * 12);
      var pl = Math.round(s.l * 12);
      if ((pw === widthIn && pl === lengthIn) || (pw === lengthIn && pl === widthIn)) return s;
    }
    return null;
  }

  // ---------- elements ----------
  var widthFtSel = document.getElementById('vrbb-width-ft');
  var widthInSel = document.getElementById('vrbb-width-in');
  var lengthFtSel = document.getElementById('vrbb-length-ft');
  var lengthInSel = document.getElementById('vrbb-length-in');

  var emptyEl = document.getElementById('vrbb-empty');
  var guardEl = document.getElementById('vrbb-guard');
  var guardBodyEl = document.getElementById('vrbb-guard-body');
  var guardSwitchBtn = document.getElementById('vrbb-guard-switch');
  var guardDeclineBtn = document.getElementById('vrbb-guard-decline');
  var summaryEl = document.getElementById('vrbb-summary');
  var summarySizeEl = document.getElementById('vrbb-summary-size');
  var standardEl = document.getElementById('vrbb-s2-standard-price');
  var tradeEl = document.getElementById('vrbb-s2-trade-price');
  var ackWrap = document.getElementById('vrbb-ack-wrap');
  var ackBox = document.getElementById('vrbb-ack');
  var orderBtn = document.getElementById('vrbb-s2-order');
  var orderForm = document.getElementById('vrbb-order-form');
  var orderErrorEl = document.getElementById('vrbb-order-error');

  if (!widthFtSel || !lengthFtSel) return;

  var EMPTY_TEXT = emptyEl ? emptyEl.textContent : '';
  var current = null;
  var declined = {};
  var pendingMatch = null;

  // ---------- dropdowns ----------
  function addOption(sel, value, label) {
    var o = document.createElement('option');
    o.value = value;
    o.textContent = label;
    sel.appendChild(o);
    return o;
  }

  for (var w = 2; w <= maxWidthFt; w++) addOption(widthFtSel, w, w + ' ft');
  addOption(widthFtSel, OVER, 'Wider than ' + formatCeiling(maxWidthIn) + '\u2026');

  function rebuildLength() {
    var selW = parseInt(widthFtSel.value, 10) || 2;
    var minL = Math.max(selW, 4);
    var keep = lengthFtSel.value;
    lengthFtSel.innerHTML = '';
    addOption(lengthFtSel, '', 'ft');
    for (var l = minL; l <= maxLengthFt; l++) {
      var op = addOption(lengthFtSel, l, l + ' ft');
      if (String(l) === keep) op.selected = true;
    }
    var over = addOption(lengthFtSel, OVER, 'Longer than ' + formatCeiling(maxLengthIn) + '\u2026');
    if (keep === OVER) over.selected = true;
  }

  // The inch list depends on the selected foot. At the top foot it stops at the
  // remainder of the ceiling; below it, the full 0-11 is safe.
  function rebuildInches(inSel, ftSel, ceilingIn) {
    if (!inSel) return;
    var topFt = Math.floor(ceilingIn / 12);
    var selFt = parseInt(ftSel.value, 10);
    var cap = (selFt === topFt) ? ceilingIn % 12 : 11;
    var keep = parseInt(inSel.value, 10) || 0;
    inSel.innerHTML = '';
    for (var i = 0; i <= cap; i++) addOption(inSel, i, i + ' in');
    inSel.value = String(Math.min(keep, cap));
  }
  function rebuildAllInches() {
    rebuildInches(widthInSel, widthFtSel, maxWidthIn);
    rebuildInches(lengthInSel, lengthFtSel, maxLengthIn);
  }

  // ---------- the oversize path ----------
  function openQuoteForm() {
    var trigger = document.querySelector('.vrbb-standalone [data-target="vrbb-quote-form"]');
    var target = document.getElementById('vrbb-quote-form');
    if (trigger && target && target.hidden) trigger.click();
  }

  // Shanna's wording. Same sentence for width and length, and it deliberately
  // states no dimension -- the ceiling is already in the dropdown option they
  // just picked. Do not reintroduce numbers, "loom width", or her name here.
  var OVERSIZE_TEXT = 'Even larger sizes are available, but we price those separately. ' +
    'Send your size request below and we will email you a price within one business day.';

  function showOversize() {
    resetPanels();
    if (emptyEl) {
      emptyEl.textContent = OVERSIZE_TEXT;
      show(emptyEl);
    }
    openQuoteForm();
  }

  // ---------- panels ----------
  function showOrderError(msg) {
    if (!orderErrorEl) { console.error('VRBB order error:', msg); return; }
    orderErrorEl.textContent = msg;
    show(orderErrorEl);
  }
  function clearOrderError() {
    if (orderErrorEl) { orderErrorEl.textContent = ''; hide(orderErrorEl); }
  }

  function resetPanels() {
    clearOrderError();
    hide(guardEl);
    hide(summaryEl);
    hide(ackWrap);
    hide(orderBtn);
    hide(orderForm);
    if (orderBtn) {
      orderBtn.textContent = ORDER_LABEL;
      orderBtn.disabled = true;
    }
    current = null;
    pendingMatch = null;
  }

  function showEmpty() {
    resetPanels();
    if (emptyEl) {
      emptyEl.textContent = EMPTY_TEXT;
      show(emptyEl);
    }
  }

  function syncOrderButton() {
    if (!orderBtn || !current) return;
    var ok = !ackBox || ackBox.checked;
    orderBtn.disabled = !ok;
    orderBtn.textContent = ORDER_LABEL + ' \u2014 ' + formatPrice(current.shown);
  }

  function showGuard(match, widthIn, lengthIn) {
    resetPanels();
    hide(emptyEl);
    pendingMatch = { match: match, key: widthIn + 'x' + lengthIn };
    if (guardBodyEl) {
      guardBodyEl.innerHTML = 'A ' + trimFt(match.w) + '\u00d7' + trimFt(match.l) + ' ' + productTitle +
        ' is in stock at <strong>' + match.p + '</strong>. It ships in 5\u20137 days instead of 12\u201316 weeks, and it\u2019s returnable.';
    }
    show(guardEl);
  }

  function showPrice(widthIn, lengthIn) {
    resetPanels();
    hide(emptyEl);

    var base = calculatePrice(rate, widthIn, lengthIn);
    var shown = isTrade ? tradePrice(base, tradeTier) : base;

    if (summarySizeEl) {
      summarySizeEl.textContent = formatDimension(widthIn) + ' \u00d7 ' + formatDimension(lengthIn);
    }
    if (isTrade) {
      if (standardEl) standardEl.textContent = formatPrice(base);
      if (tradeEl) tradeEl.textContent = formatPrice(shown);
    } else if (standardEl) {
      standardEl.textContent = formatPrice(base);
    }

    current = {
      widthIn: widthIn,
      lengthIn: lengthIn,
      base: base,
      shown: shown,
      tierLabel: isTrade ? (tradeTier === 'vip' ? '25% Trade VIP Discount' : '20% Trade Discount') : 'standard'
    };

    show(summaryEl);
    show(ackWrap);
    show(orderBtn);
    if (ackBox) ackBox.checked = false;
    syncOrderButton();
  }

  // ---------- main ----------
  function update() {
    var wFt = widthFtSel.value;
    var lFt = lengthFtSel.value;

    if (wFt === OVER) { showOversize(); return; }
    if (lFt === OVER) { showOversize(); return; }
    if (!wFt || !lFt) { showEmpty(); return; }

    var widthIn = toInches(parseInt(wFt, 10), parseInt(widthInSel.value, 10));
    var lengthIn = toInches(parseInt(lFt, 10), parseInt(lengthInSel.value, 10));

    // Belt and braces: rebuildInches should make these unreachable.
    if (widthIn > maxWidthIn) { showOversize(); return; }
    if (lengthIn > maxLengthIn) { showOversize(); return; }

    var match = matchInStock(widthIn, lengthIn);
    if (match && !declined[widthIn + 'x' + lengthIn]) {
      showGuard(match, widthIn, lengthIn);
      return;
    }
    showPrice(widthIn, lengthIn);
  }

  rebuildLength();
  rebuildAllInches();
  widthFtSel.addEventListener('change', function () { rebuildLength(); rebuildAllInches(); update(); });
  widthInSel.addEventListener('change', update);
  lengthFtSel.addEventListener('change', function () { rebuildAllInches(); update(); });
  lengthInSel.addEventListener('change', update);
  if (ackBox) ackBox.addEventListener('change', syncOrderButton);

  // Switching happens on the page: flip to the Ready to ship tab, then set the
  // size in Dawn's variant picker so it updates price and Add to cart itself.
  // Navigation is the fallback only, for a picker we can't find.
  function labelsMatch(a, b) {
    if (!a || !b) return false;
    return String(a).replace(/\s+/g, '').toLowerCase() === String(b).replace(/\s+/g, '').toLowerCase();
  }
  function selectStockedVariant(m) {
    var scope = document.querySelector('.product__info-container') || document;
    var radios = scope.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (labelsMatch(radios[i].value, m.o1) || labelsMatch(radios[i].value, m.t)) {
        if (!radios[i].checked) {
          radios[i].checked = true;
          radios[i].dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      }
    }
    var sels = scope.querySelectorAll('select');
    for (var j = 0; j < sels.length; j++) {
      for (var k = 0; k < sels[j].options.length; k++) {
        var opt = sels[j].options[k];
        if (labelsMatch(opt.value, m.o1) || labelsMatch(opt.value, m.t)) {
          sels[j].value = opt.value;
          sels[j].dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      }
    }
    return false;
  }

  if (guardSwitchBtn) {
    guardSwitchBtn.addEventListener('click', function () {
      if (!pendingMatch) return;
      var m = pendingMatch.match;
      var stockTab = document.getElementById('vrbb-path-stock');
      if (stockTab) stockTab.click();
      if (selectStockedVariant(m)) return;
      if (stockTab) stockTab.click();
      guardSwitchBtn.disabled = true;
      guardSwitchBtn.textContent = 'Switching\u2026';
      window.location.href = m.u;
    });
  }
  if (guardDeclineBtn) {
    guardDeclineBtn.addEventListener('click', function () {
      if (!pendingMatch) return;
      declined[pendingMatch.key] = true;
      update();
    });
  }

  // ---------- shortcuts ----------
  var shortcuts = document.querySelectorAll('.vrbb-shortcut');
  Array.prototype.forEach.call(shortcuts, function (btn) {
    btn.addEventListener('click', function () {
      widthFtSel.value = parseInt(btn.dataset.width, 10);
      rebuildLength();
      lengthFtSel.value = parseInt(btn.dataset.length, 10);
      rebuildAllInches();
      widthInSel.value = 0;
      lengthInSel.value = 0;
      update();
    });
  });

  // ---------- order ----------
  function openCustomOrderForm() {
    if (!current) return;
    var wDisp = formatDimension(current.widthIn);
    var lDisp = formatDimension(current.lengthIn);
    var priceStr = formatPrice(current.shown);

    setText('vrbb-order-width-display', wDisp);
    setText('vrbb-order-length-display', lDisp);
    setText('vrbb-order-price-display', priceStr);
    setVal('vrbb-order-width-hidden', wDisp);
    setVal('vrbb-order-length-hidden', lDisp);
    setVal('vrbb-order-price-hidden', priceStr);

    show(orderForm);
  }

  function submitDraftOrder() {
    if (!current) return;
    clearOrderError();
    orderBtn.textContent = 'Processing\u2026';
    orderBtn.disabled = true;
    if (window.vrbbShowOverlay) window.vrbbShowOverlay();

    fetch(DRAFT_ORDER_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        product_id: dataEl.dataset.productId || null,
        vendor: dataEl.dataset.vendor || null,
        dimensions: {
          width_ft: parseInt(widthFtSel.value, 10),
          width_in: parseInt(widthInSel.value, 10),
          length_ft: parseInt(lengthFtSel.value, 10),
          length_in: parseInt(lengthInSel.value, 10)
        }
      })
    })
      .then(function (r) {
        return r.text().then(function (body) {
          var data = null;
          try { data = JSON.parse(body); } catch (e) {}
          return { ok: r.ok, status: r.status, data: data };
        });
      })
      .then(function (res) {
        if (res.ok && res.data && res.data.invoice_url) {
          window.location.href = res.data.invoice_url;
          return;
        }
        if (window.vrbbHideOverlay) window.vrbbHideOverlay();
        syncOrderButton();
        // The proxy returns readable messages ("Width exceeds the maximum for this
        // rug (8.92 ft)"). Show them -- silent failure is what made this hard to find.
        var msg = res.data && (res.data.error || res.data.message);
        showOrderError(msg || 'We couldn\u2019t start this order. Please try again, or send your size below and Shanna will email you a price.');
        console.error('VRBB draft-order failed', res.status, res.data);
      })
      .catch(function (err) {
        if (window.vrbbHideOverlay) window.vrbbHideOverlay();
        syncOrderButton();
        showOrderError('We couldn\u2019t reach the order system just now. Please try again, or send your size below and Shanna will email you a price.');
        console.error('VRBB draft-order error:', err);
      });
  }

  if (orderBtn) {
    orderBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!current || orderBtn.disabled) return;
      if (CUSTOM_CHECKOUT_ENABLED) submitDraftOrder();
      else openCustomOrderForm();
    });
  }

  // ---------- back-button recovery ----------
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) update();
  });

  // ---------- fallback form submit flag ----------
  var orderFormEl = document.getElementById('vrbb-order-form-el');
  if (orderFormEl) {
    orderFormEl.addEventListener('submit', function () {
      try { window.sessionStorage.setItem('vrbb_order_submitted', '1'); } catch (e) {}
    });
  }

  // ---------- expandables: only one open at a time ----------
  var allTriggers = document.querySelectorAll('.vrbb-expandable-trigger');
  Array.prototype.forEach.call(allTriggers, function (trigger) {
    trigger.addEventListener('click', function () {
      var targetId = trigger.dataset.target;
      Array.prototype.forEach.call(allTriggers, function (other) {
        if (other.dataset.target !== targetId) {
          var otherTarget = document.getElementById(other.dataset.target);
          if (otherTarget && !otherTarget.hidden) {
            otherTarget.hidden = true;
            other.setAttribute('aria-expanded', 'false');
            other.classList.remove('vrbb-open');
          }
        }
      });
    });
  });

  // ---------- deep-link prefill ----------
  // A feed link naming a size that isn't on the shelf. Step D has already opened this
  // tab; filling the size in means the shopper isn't asked to retype what they clicked.
  // The Liquid block only emits these when the SELECTED variant has no stock, so a link
  // to a stocked size never reaches here and the in-stock guard cannot fire on a prefill.
  // Anything that doesn't fit this rug's own dropdowns is left alone rather than forced.
  function applyPrefill() {
    var pw = parseFloat(dataEl.dataset.prefillWidthFt);
    var pl = parseFloat(dataEl.dataset.prefillLengthFt);
    if (!(pw > 0) || !(pl > 0)) return false;

    var wIn = Math.round(pw * 12);
    var lIn = Math.round(pl * 12);
    if (wIn > maxWidthIn || lIn > maxLengthIn) return false;

    var wFt = Math.floor(wIn / 12);
    var lFt = Math.floor(lIn / 12);

    widthFtSel.value = String(wFt);
    if (widthFtSel.value !== String(wFt)) return false;

    rebuildLength();
    lengthFtSel.value = String(lFt);
    if (lengthFtSel.value !== String(lFt)) return false;

    rebuildAllInches();
    if (widthInSel) widthInSel.value = String(wIn % 12);
    if (lengthInSel) lengthInSel.value = String(lIn % 12);

    update();
    return true;
  }

  if (!applyPrefill()) showEmpty();
})();